import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  Component,
  ElementRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/authentication/authentication.service';

@Component({
  selector: 'app-expire-password-reminder-modal',
  templateUrl: './expire-password-reminder-modal.component.html',
  styleUrls: ['./expire-password-reminder-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ExpirePasswordReminderModalComponent {
  @ViewChild('expireModal') expireModal: ElementRef;

  constructor(
    private modal: NgbModal,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  goToChangePassword(): void {
    this.router.navigate(['/change-password']);
    this.modal.dismissAll();
  }

  open(): void {
    this.modal.open(this.expireModal, {
      centered: true,
      size: 'lg',
      windowClass: 'expire-ngb-modal-window',
      backdropClass: 'expire-ngb-modal-backdrop',
    });
  }

  get days(): number {
    return this.authService.currentUserValue.user.password_age_left_days;
  }
}
